import { isBoolean } from 'lodash';
import { connect } from 'react-redux';
import { compose, renderNothing, withPropsOnChange } from 'recompose';

import WithShop from '../hoc/WithShop';
import { fetchThirdPartyPromoStatus } from '../actions';
import WithThirdPartyPromo from '../hoc/WithThirdPartyPromo';

const mapDispatchToProps = {
  fetchThirdPartyPromotions: fetchThirdPartyPromoStatus,
};

export default compose(
  WithThirdPartyPromo,
  WithShop,
  connect(null, mapDispatchToProps),
  withPropsOnChange(
    ['shop'],
    (props) => {
      const isPromoLoaded = isBoolean(props.thirdPartyPromo.active);
      if (props.shop && !isPromoLoaded) {
        props.fetchThirdPartyPromotions(props.shop.brandId, props.shop.id);
      }
    }),
)(renderNothing());



// WEBPACK FOOTER //
// ./src/app/hoc/ThirdPartyPromotion.jsx